import { Box, Container, Divider, Link, Stack, Typography } from '@mui/material';
import { otaColors } from '../theme/palette';

interface OtaFooterColumn {
  title: string;
  links: { label: string; href: string }[];
}

interface OtaFooterProps {
  columns?: OtaFooterColumn[];
}

const DEFAULT_COLUMNS: OtaFooterColumn[] = [
  // {
  //   title: 'Company',
  //   links: [
  //     { label: 'About OTA', href: '#' },
  //     { label: 'Careers', href: '#' },
  //     { label: 'Press', href: '#' },
  //   ],
  // },
  // {
  //   title: 'For Travelers',
  //   links: [
  //     { label: 'How it works', href: '#' },
  //     { label: 'Cancellation', href: '#' },
  //     { label: 'Customer support', href: '#' },
  //   ],
  // },
  // {
  //   title: 'For Hoteliers',
  //   links: [
  //     { label: 'List your property', href: 'https://propertyenlist.dataman.in' },
  //     { label: 'Hotelier dashboard', href: 'https://otainternal.dataman.in' },
  //   ],
  // },
];

export function OtaFooter({ columns = DEFAULT_COLUMNS }: OtaFooterProps) {
  return (
    <Box component="footer" sx={{ mt: 8, backgroundColor: otaColors.background.dark, color: '#E6EEF7' }}>
      <Container maxWidth="xl" sx={{ py: 6 }}>
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={6} justifyContent="space-between">
          <Box sx={{ maxWidth: 360 }}>
            <Typography variant="h5" sx={{ color: '#fff', fontWeight: 700 }}>
              OTA
            </Typography>
            <Typography variant="body2" sx={{ mt: 1, color: '#B5C2D2' }}>
              Hotel booking made simple. A Dataman product.
            </Typography>
          </Box>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={6}>
            {columns.map((col) => (
              <Stack key={col.title} spacing={1.25}>
                <Typography variant="overline" sx={{ color: '#fff' }}>
                  {col.title}
                </Typography>
                {col.links.map((l) => (
                  <Link key={l.label} href={l.href} underline="hover" color="#B5C2D2" variant="body2">
                    {l.label}
                  </Link>
                ))}
              </Stack>
            ))}
          </Stack>
        </Stack>

        <Divider sx={{ my: 4, borderColor: 'rgba(255,255,255,0.1)' }} />
        <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" spacing={1}>
          <Typography variant="caption" sx={{ color: '#90A0B5' }}>
            © {new Date().getFullYear()} Dataman. All rights reserved.
          </Typography>
          <Stack direction="row" spacing={3}>
            {/* <Link href="#" underline="hover" color="#90A0B5" variant="caption">Privacy</Link>
            <Link href="#" underline="hover" color="#90A0B5" variant="caption">Terms</Link>
            <Link href="#" underline="hover" color="#90A0B5" variant="caption">Cookies</Link> */}
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
